import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { AccountState } from './account-state.model';

@Injectable({ providedIn: 'platform' })
@StoreConfig({
  name: 'account',
  resettable: true,
})
export class AccountStateStore extends Store<AccountState> {
  public constructor() {
    super(AccountStateStore.getInitialState());
  }

  private static getInitialState(): AccountState {
    return {};
  }
}
